import $ from "cash-dom";

export default class ScrollfocusModule {

    static name = 'scrollfocus'

    constructor(node) {

        $(node).on('mouseenter', function() {
            this.focus();
        });
    }
}